exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".accordion .card-header{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center;background-color:#fff;font-weight:600}.accordion .card-header svg{rotate:0deg;transition-duration:.3s;transition-property:rotate}.accordion .card-header svg.active{rotate:-180deg}.accordion .card-body{font-size:.9rem;white-space:pre-line;line-height:.75rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/common/accordion/accordion.scss
// module id = 5941
// module chunks = 0